import React, { FC, useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/auth-plus.context";
import { Spinner } from "react-bootstrap";

const ProtectedRoute: FC = () => {
  const { auth, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <></>;
  }

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
